module.exports = __webpack_public_path__ + "img/icon10.31c97645.png";